module.exports = __webpack_public_path__ + "media/5_Long.c43ac7e6.mp3";